import { FormControl } from '@angular/forms';
import { Pipe, PipeTransform } from '@angular/core';
import { ValidationUtilService } from 'app'


@Pipe({
  name: 'validationError'
})
export class ValidationErrorPipe implements PipeTransform {

  constructor(private validationUtilService: ValidationUtilService) {

  }

  transform(fieldFormControlValue: string, fieldFormControl: FormControl, FORMNAME, state?: string): Array<any>[] {
    return this.validationUtilService.getUIErrorList(fieldFormControl, FORMNAME, state)
  }

}
